import React, { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { api } from "../lib/api";
import { logger } from "../lib/logger";

export default function PayPalCheckout({ sessionId, disabled = false, onBeforeOrder, onPaid }) {
    const [cfg, setCfg] = useState(null);

    useEffect(() => {
        api.paypalConfig().then(setCfg).catch(err => logger.warn("paypal config failed:", err));
    }, []);

    if (!cfg?.enabled || !cfg.client_id) return null;

    return (
        <div data-testid="paypal-section" className={disabled ? "opacity-50 pointer-events-none" : ""}>
            <div className="my-3 flex items-center gap-3 text-[9px] tracking-[0.28em] uppercase text-ink-light">
                <span className="h-px flex-1 bg-burgundy/15" />
                or pay with
                <span className="h-px flex-1 bg-burgundy/15" />
            </div>
            <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: cfg.currency, intent: "capture", components: "buttons" }}>
                <PayPalButtons
                    style={{ layout: "horizontal", color: "black", shape: "rect", height: 48, tagline: false }}
                    disabled={disabled}
                    forceReRender={[disabled]}
                    createOrder={async () => {
                        await onBeforeOrder?.();
                        const res = await api.paypalCreateOrder(sessionId);
                        return res.order_id;
                    }}
                    onApprove={async (data) => {
                        try {
                            const res = await api.paypalCapture(data.orderID, sessionId);
                            if (res.status === "COMPLETED") onPaid?.(res.founding_member_number);
                            else toast.error("PayPal payment is still pending. We'll unlock you as soon as it clears.");
                        } catch (err) {
                            logger.error("paypal capture failed:", err);
                            toast.error("PayPal payment could not be completed.");
                        }
                    }}
                    onError={(err) => {
                        logger.error("paypal error:", err);
                        toast.error("PayPal is unavailable right now. Try card checkout instead.");
                    }}
                />
            </PayPalScriptProvider>
        </div>
    );
}
